export default __webpack_public_path__ + "static/media/cci.e5782eaa.png";